<template>
  <Modal title="認証キーの登録" @close="close" size="big">
    <LoadingIndicator v-if="busy" />
    <template>
      <p>
        レスラクとの連携には、連携サービスに関する重要事項に同意いただき、レスラク管理画面に表示された認証キーを入力する必要があります。
      </p>
      <div class="term" ref="term" @scroll="checkScrollTerm">
        <p class="term-text" v-html="termText" />
      </div>
      <CheckBox v-model="confirmed" :disabled="checkBoxDisable">同意する</CheckBox>
      <div class="auth-key">
        <TextInput placeholder="認証キー" v-model.trim="authKey" />
      </div>
    </template>

    <template #footer-center>
      <Button @click="close">戻る</Button>
      <Button primary @click="register" :disabled="!authKey || !confirmed">登録</Button>
    </template>
  </Modal>
</template>
<script>
import { mapState } from 'vuex'
import { throttle } from 'lodash'
import Button from '@/components/atoms/Button'
import CheckBox from '@/components/atoms/CheckBox'
import TextInput from '@/components/atoms/TextInput'
import Modal from '@/components/molecules/Modal'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'

export default {
  name: 'ResrakuSyncRegisterModal',
  components: {
    Button,
    CheckBox,
    TextInput,
    Modal,
    LoadingIndicator,
  },
  data() {
    return {
      authKey: '',
      confirmed: false,
      checkBoxDisable: true,
    }
  },
  computed: {
    ...mapState({
      busy: state => state.resraku.auth.busy,
    }),
    termText() {
      return '「ぐるなび台帳」「レスラク」連携サービスに関する重要事項説明\n\n\n本サービスの利用者（以下「利用者」といいます）は、「ぐるなび台帳」「レスラク」連携サービス（以下、「本サービス」という）の利用に際し、下記注意事項に同意の上、本サービスの利用を開始するものとします。\n\n【本サービスの概要】\n・本サービスは飲食店様において、複数のグルメサイトの予約・在庫管理業務が一括で操作できることによる生産性と利便性を向上するためのサービスです。\n・本サービスでは、ユーザーが外部グルメサイト（レスラク社が別途指定するサイトに限ります。以下同じ）にて行った飲食店利用予約にかかる情報（以下「外部サイト予約情報」）がレスラクを通し、ぐるなび台帳に予約情報（以下「予約情報」といいます）として反映されます。また、予約情報に含まれる個人情報についても同様にぐるなび台帳の顧客情報として保存されます。\n・予約情報の具体的内容は、外部サイト予約情報の内容により異なります。\n・利用者は本サービスの利用にあたり、各社が運営するグルメサイトのシステムへアクセスするために必要な情報を、株式会社ぐるなび（以下「当社」といいます）及び、株式会社レスラク（以下「レスラク社」）に開示することを、自らの責任のもと、同意するものとします。\n\n【個人情報の取り扱いについて】\n・本サービスのご利用に際し、当社は、レスラク社より、本サービスにかかる予約者情報（個人情報）の取り扱い業務を受託しています。\n\n【免責事項】\n・本サービスのご利用は、オーバーブッキング等の予約に関するリスクを軽減することはできますが、これらのリスクを完全に排除するものではございません。\n・本サービスのご利用に起因して、予約に関するトラブルが生じた場合であっても当社は責任を負いません。ただし、当該トラブルが当社の責めに帰すべき事由に基づく場合はこの限りではありません。\n・以下に掲げる場合、外部サイト予約情報が予約情報として反映されない場合がありますので事前にご承知置きをお願いいたします。\n1 外部グルメサイト側の事情で飲食店利用予約の受付ができない状態になっている場合\n2 外部グルメサイトが利用者に送付する外部サイト予約情報に関するメールの形式等に変更があった場合\n3 外部グルメサイトにて提供されるサービス内容または仕様の変更、または外部グルメサイトが終了した場合\n4 当社ウェブサイト上の利用者が管理・運営する店舗にかかる情報掲載ページにおける飲食店利用予約機能が停止となった日から起算して61日が経過した場合\n5 その他、当社ウェブサイトまたは外部グルメサイトのシステム不具合、システムメンテナンスが発生した場合\n6 利用者が、「ぐるなび台帳利用条件」その他当社が定める諸条件に違反した場合\n\n以上\n制定日：2021年4月1日\n'
    },
  },
  methods: {
    /* eslint-disable */
    checkScrollTerm: throttle(function() {
      const { clientHeight, scrollHeight, scrollTop } = this.$refs.term
      if (clientHeight + scrollTop + 64 >= scrollHeight) this.checkBoxDisable = false
    }, 200),
    /* eslint-disable */
    close() {
      this.$emit('close')
    },
    register() {
      this.$emit('register', { authKey: this.authKey })
    },
  },
}
</script>

<style lang="postcss" scoped>
.term {
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  color: #5a5a5a;
  display: inline-block;
  font-size: 14px;
  height: 300px;
  overflow: auto;
  padding: 12px 16px;
  white-space: pre-wrap;
  width: 100%;
}

.check-box {
  justify-self: center;
}

.auth-key {
  > input {
    height: 48px;
  }
}
</style>
